import React, {Component} from 'react';
import css from './footer.scss';

class Footer extends Component {
	render() {
		return (
			<footer className={css.footer}>
				Création & réalisation :{' '}
				<a href="https://adelios.fr" target="_blank" rel="noopener noreferrer">
					Adelios
				</a>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/footer/footer.js